import React from 'react';
import { MediaImage, mediaPath, useMediaAsset } from './MediaUtils';
import { AudioPlayer } from '../../components/AudioPlayer/AudioPlayer';
import { FilePreview } from '../../components/FilePreview/FilePreview';
import { VideoPlayer } from '../../components/VideoPlayer/VideoPlayer';
import { StyledA, StyledImg, StyledP } from '../../styles/StyledHTML';
import { SmartContainer } from '../../styles/Containers';
import { IconDownload } from '../../capturecollab/Icons';


export const MediaPreview = ({ item, crop = null }) => {

    const renderMedia = () => {
        // if (item?.mediaType === 'image') return (<StyledImg radius src={mediaPath(item.meta.path, item.meta.storage)} />);
        if (item?.mediaType === 'image') return (<MediaImage radius image={item} crop={crop} />)
        if (item?.mediaType === 'audio') return (<AudioPlayer src={mediaPath(item.meta.path, item.meta.storage)} />);
        if (item?.mediaType === 'doc') return (<FilePreview src={mediaPath(item.meta.path, item.meta.storage)} />);
        if (item?.mediaType === 'video') return (<VideoPlayer src={mediaPath(item.meta.path, item.meta.storage)} />);
        return (<div></div>)
    }
    return (
        <SmartContainer width="100%" data-preview>{renderMedia()}</SmartContainer>
    )
}

export const MediaPreviewAsText = ({ id, network = false }) => {

    const { assetLoading, assetPath, assetSrc, activeMedia } = useMediaAsset({ id, network, noCache: true });
    if (!activeMedia) return (<SmartContainer>&nbsp;</SmartContainer>)

    return (
        <SmartContainer flex align="center" justify="space-between">
            <StyledP small ellipsis>{activeMedia?.name}</StyledP>
            <StyledP small light><a download small href={assetSrc} target="_blank"><IconDownload /></a></StyledP>
        </SmartContainer>
    )
}